import Box from '@mui/material/Box';

import Icon from '../Icon';

import {
  StyledDrawer,
  DrawerHeader,
  Title,
  StyledButton,
  StyledBox,
} from './styles';
import type { HapDrawerMobileProps } from './types';
import { NEW_COLORS } from '../../themes/colors/newColors';

export const HapDrawerMobile = ({
  title,
  anchor,
  children,
  openDrawer,
  setDrawerOpen,
}: HapDrawerMobileProps) => {
  return (
    <StyledDrawer
      anchor={anchor}
      open={openDrawer}
      onClose={setDrawerOpen}
      elevation={0}
      sx={{ flexShrink: 1 }}
    >
      <StyledBox anchor={anchor} role="presentation">
        <DrawerHeader>
          <StyledButton onClick={() => setDrawerOpen()}>
            <Icon
              name="actions-b2b-close"
              color={NEW_COLORS.SECONDARY[500]}
              size={20}
            />
          </StyledButton>
          <Title variant="subtitle1">{title}</Title>
        </DrawerHeader>
        <Box height="calc(100% - 70px)">{children}</Box>
      </StyledBox>
    </StyledDrawer>
  );
};
